/**
 * W1-TODAY-HERO (TH-8, strings 11 and 12) — the primary "Start run" and the one
 * line under it. A link to the Run tab (`/run`, registered in App.tsx), because it
 * only navigates; the Run screen owns recording and GPS consent. The helper line
 * lives in this component and nowhere else, so it can never render without the
 * link above it.
 */
import { useId } from 'react';
import { Link } from 'react-router-dom';
import styles from './StartRunBlock.module.css';

export function StartRunBlock() {
  const helperId = useId();
  return (
    <>
      <Link to="/run" className={styles.start} aria-describedby={helperId}>
        Start run
      </Link>
      <p id={helperId} className={styles.helper}>
        Opens the Run tab and records with GPS.
      </p>
    </>
  );
}
